<div class="preview-toolbar">
  <div
    class="preview-toolbar__zoom-controls"
    aria-label="Preview zoom controls"
  >
    <button
      type="button"
      class="preview-toolbar__icon-button"
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.ZOOM_OUT_LABEL"
      [title]="MESSAGES.DOCX_PREVIEW.ZOOM_OUT_LABEL"
      (click)="emitToolbarAction('zoomOut')"
    >
      <svg
        class="preview-toolbar__icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4 9H14"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <button
      type="button"
      class="preview-toolbar__icon-button"
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.ZOOM_IN_LABEL"
      [title]="MESSAGES.DOCX_PREVIEW.ZOOM_IN_LABEL"
      (click)="emitToolbarAction('zoomIn')"
    >
      <svg
        class="preview-toolbar__icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4 9H14"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M9 4V14"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <div class="preview-toolbar__zoom-select-wrapper">
      <select
        class="preview-toolbar__zoom-select"
        [value]="selectedZoomPreset"
        [disabled]="!previewState.rendered"
        [attr.aria-label]="MESSAGES.DOCX_PREVIEW.ZOOM_SELECT_LABEL"
        (change)="emitZoomPresetChange($any($event.target).value)"
      >
        <option *ngIf="showCurrentZoomOption" value="current">
          {{ currentZoomPercentageLabel }}
        </option>
        <option *ngFor="let option of zoomOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
      <span class="preview-toolbar__zoom-chevron" aria-hidden="true">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 3.5L5 6.5L8 3.5"
            stroke="currentColor"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </div>

  <div class="preview-toolbar__actions">
    <button
      type="button"
      class="preview-toolbar__button preview-toolbar__button--toggle preview-toolbar__button--icon-only"
      [class.preview-toolbar__button--active]="
        previewState.highlightModeEnabled
      "
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.HIGHLIGHT_LABEL"
      [attr.aria-pressed]="previewState.highlightModeEnabled"
      [title]="MESSAGES.DOCX_PREVIEW.HIGHLIGHT_LABEL"
      (click)="emitToolbarAction('toggleHighlight')"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="preview-toolbar__icon"
        aria-hidden="true"
      >
        <path
          d="M15 12.75V3.75C15 2.90925 14.3408 2.25 13.5 2.25C12.6592 2.25 12 2.90925 12 3.75V12.75L13.5 14.25L15 12.75Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 5.25H15"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 14.25H3.75C3.35218 14.25 2.97064 14.092 2.68934 13.8107C2.40804 13.5294 2.25 13.1478 2.25 12.75C2.25 12.3522 2.40804 11.9706 2.68934 11.6893C2.97064 11.408 3.35218 11.25 3.75 11.25H6.75C7.14782 11.25 7.52936 11.092 7.81066 10.8107C8.09196 10.5294 8.25 10.1478 8.25 9.75C8.25 9.35218 8.09196 8.97064 7.81066 8.68934C7.52936 8.40804 7.14782 8.25 6.75 8.25H4.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <button
      type="button"
      class="preview-toolbar__button preview-toolbar__button--icon-only"
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.PRINT_LABEL"
      [title]="MESSAGES.DOCX_PREVIEW.PRINT_LABEL"
      (click)="emitToolbarAction('print')"
    >
      <svg
        class="preview-toolbar__icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6 14.25H5C3.75736 14.25 2.75 13.2426 2.75 12V8C2.75 6.75736 3.75736 5.75 5 5.75H15C16.2426 5.75 17.25 6.75736 17.25 8V12C17.25 13.2426 16.2426 14.25 15 14.25H14"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 5.75V3.75H13.25V5.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 10.75H13.25V16.25H6.75V10.75Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <button
      type="button"
      class="preview-toolbar__button preview-toolbar__button--icon-only"
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.DOWNLOAD_LABEL"
      [title]="MESSAGES.DOCX_PREVIEW.DOWNLOAD_LABEL"
      (click)="emitToolbarAction('download')"
    >
      <svg
        class="preview-toolbar__icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M10 3.75V11.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M7.25 8.75L10 11.25L12.75 8.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.75 14.25H15.25V16.25H4.75V14.25Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <button
      type="button"
      class="preview-toolbar__button preview-toolbar__button--icon-only"
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.ROTATE_LEFT_LABEL"
      [title]="MESSAGES.DOCX_PREVIEW.ROTATE_LEFT_LABEL"
      (click)="emitToolbarAction('rotateLeft')"
    >
      <svg
        class="preview-toolbar__icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6 4.75H10.5C14.2279 4.75 17.25 7.77208 17.25 11.5C17.25 15.2279 14.2279 18.25 10.5 18.25C7.81768 18.25 5.5092 16.6925 4.42041 14.4344"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 2.75L6 4.75L8.25 6.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <button
      type="button"
      class="preview-toolbar__button preview-toolbar__button--icon-only"
      [disabled]="!previewState.rendered"
      [attr.aria-label]="MESSAGES.DOCX_PREVIEW.ROTATE_RIGHT_LABEL"
      [title]="MESSAGES.DOCX_PREVIEW.ROTATE_RIGHT_LABEL"
      (click)="emitToolbarAction('rotateRight')"
    >
      <svg
        class="preview-toolbar__icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style="transform: scaleX(-1)"
      >
        <path
          d="M6 4.75H10.5C14.2279 4.75 17.25 7.77208 17.25 11.5C17.25 15.2279 14.2279 18.25 10.5 18.25C7.81768 18.25 5.5092 16.6925 4.42041 14.4344"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 2.75L6 4.75L8.25 6.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</div>
